<div class="page-wrapper" [ngClass]="responsive.screenClass | async">
    <header class="navheader align-con-cen" id="header">
        <div class="flex justify-between items-center w-full h-full px-4 sm:px-6 lg:px-8">
            <!-- Left Side (Logo + Burger) -->
            <div class="flex-shrink-0 flex items-center">
                <a [routerLink]="'/dashboard'" class="mr-6">
                    <img
                        class="h-12 w-auto"
                        src="../../../assets/images/logo/logo.png"
                        alt="AethyrTech"
                    />
                </a>
            </div>

            <!-- Right Side (Desktop View) -->
            <div class="flex items-center gap-4 desktop-only">
                <div class="flex flex-col text-right">
                    <span class="text-[10px] font-bold text-slate-400 tracking-wider uppercase">{{
                        (user?.role || 'User Account').replace('_', ' ')
                    }}</span>
                    <span class="text-sm font-bold text-[#0B132B]">{{ user?.name || 'User' }}</span>
                </div>

                <!-- Avatar -->
                <div
                    class="w-10 h-10 rounded-full bg-[#0B132B] border border-gray-200 flex items-center justify-center shadow-sm cursor-pointer hover:ring-2 ring-gray-200 transition-all"
                    (click)="openProfile()"
                    (keydown.enter)="openProfile()"
                    tabindex="0"
                    title="Profile"
                >
                    <span class="text-[#38bdf8] font-bold text-lg">{{
                        (user?.name || 'U').charAt(0).toUpperCase()
                    }}</span>
                </div>

                <!-- Logout -->
                <button
                    class="w-10 h-10 rounded-2xl bg-red-50 text-red-500 hover:bg-red-100 transition-colors flex items-center justify-center cursor-pointer ml-2"
                    (click)="logout()"
                    title="Logout"
                >
                    <i class="fa-solid fa-arrow-right-from-bracket text-lg"></i>
                </button>
            </div>

            <!-- Mobile View -->
            <div class="flex-gap2 mobile-only">
                <!-- Burger Menu (emit to toggle sidenav) -->
                <button mat-icon-button (click)="toggleCollapse()">
                    <i class="fa-solid" [ngClass]="isCollapsed ? 'fa-xmark' : 'fa-bars'"></i>
                </button>

                <button class="profile-btn" (click)="openProfile()" title="Profile">
                    <i class="fa-solid fa-user fa-lg"></i>
                </button>

                <button class="remove-btn" (click)="logout()">
                    <i class="fa-solid fa-right-from-bracket fa-lg" style="color: #74c0fc"></i>
                </button>
            </div>
        </div>
    </header>
</div>
